import React from "react";
import { FilterButton } from "../Buttons/FilterButton";

const ColumnHeader = React.memo(
  ({
    header,
    isPinned,
    getPinnedColumnStyle,
    columnId,
    hoveredColumn,
    isVertical,
    isDynamicColumn,
    isAnalyticsTable,
    children,
    onMouseEnter,
    onMouseLeave,
    onDragStart,
    onDragOver,
    onDragEnd,
    onDrop,
    onResizeStart,
    isResizing,
    resizingColumnId,
    hasActiveFiltersOrSorting,
    onFilterButtonClick,
    ...props
  }) => {
    const style = {
      ...props.style,
      borderRight: "2px solid #fff", // Add this line
    };

    // Determine if this column is currently being resized
    const isCurrentlyResizing = isResizing;

    return (
      <th
        {...props}
        style={style}
        data-column-id={columnId}
        data-is-hovered={hoveredColumn === columnId ? "true" : "false"}
        className={`
        px-6 py-3 text-left text-xs tracking-wider relative bg-[#F4F7FE]
        ${
          isPinned
            ? "pinned-column pinned-column-header pinned-column-shadow"
            : ""
        }
        ${hoveredColumn === columnId ? "bg-blue-50" : ""}
        ${!isPinned ? "cursor-move" : ""}
        ${isCurrentlyResizing ? "resizing" : ""}
      `}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        draggable={!isPinned}
        onDragStart={!isPinned ? onDragStart : null}
        onDragOver={onDragOver}
        onDragEnd={onDragEnd}
        onDrop={onDrop}
      >
        {children}

        {/* Filter button under the column header - only for standard columns */}
        {!columnId.startsWith("P") &&
          !columnId.startsWith("F") &&
          columnId !== "output" &&
          columnId !== "actions" &&
          !isVertical && (
            <FilterButton
              isActive={hasActiveFiltersOrSorting}
              onClick={onFilterButtonClick}
              columnId={columnId}
            />
          )}

        {/* Enhanced resizer with better visual feedback */}
        <div
          onMouseDown={(e) => onResizeStart(e, columnId)}
          className={`column-resizer ${isCurrentlyResizing ? "active" : ""}`}
        />
      </th>
    );
  }
);

export default ColumnHeader;
